function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoscow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "moscow",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D7F3FF"
    },
    cx: 256.003,
    cy: 256.003,
    r: 249.99
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90BC42"
    },
    d: "M502.194,299.531c-0.938,5.436-2.068,10.811-3.379,16.114h-91.347 c9.344-19.866,29.547-33.636,52.973-33.636C476.796,282.01,491.576,288.72,502.194,299.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87AA39"
    },
    d: "M470.629,282.913c-3.311-0.582-6.712-0.902-10.189-0.902c-23.426,0-43.629,13.769-52.973,33.636 h20.444C435.859,298.747,451.667,286.267,470.629,282.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M492.742,336.498c-4.558,13.409-10.222,26.3-16.884,38.578v-16.668l-13.769,10.017l-13.769-10.017 v32.205h-25.531v-32.205l-13.769,10.017l-13.769-10.017v32.205h-25.507v-32.205l-12.17,8.863v-51.626h49.895h91.347 C497.095,322.717,495.051,329.68,492.742,336.498z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M475.858,358.409v16.668c-4.498,8.286-9.452,16.283-14.828,23.967h-0.012 c-34.021,48.716-84.986,84.721-144.332,99.525V460.82v-3.271v-31.676v-35.259h25.531v-32.205l13.769,10.017l1.587-1.154 l12.17-8.863v32.205h25.506v-32.205l13.769,10.017l13.769-10.017v32.205h25.531v-32.205l13.769,10.017L475.858,358.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M316.686,460.82v37.749c-11.641,2.91-23.594,4.991-35.825,6.205v-47.225h35.825V460.82z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "316.686,425.873 316.686,457.549 280.861,457.549 256.401,443.924 231.953,457.549 195.323,457.549 195.323,425.873 196.261,425.873 313.379,425.873 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "316.686,390.614 316.686,425.873 313.379,425.873 196.261,425.873 195.323,425.873 195.323,390.614 195.323,338.037 214.203,338.037 298.262,338.037 316.686,338.037 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M298.262,263.43v74.607h-84.06V263.43h10.39h63.279H298.262z M279.851,300.734 c0-13.036-10.571-23.618-23.618-23.618c-13.036,0-23.606,10.583-23.606,23.618c0,13.036,10.571,23.606,23.606,23.606 C269.281,324.34,279.851,313.77,279.851,300.734z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "287.872,232.728 287.872,263.43 224.593,263.43 224.593,232.728 242.547,232.728 269.93,232.728 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "287.872,173.225 287.872,232.728 269.93,232.728 269.93,229.89 269.93,174.175 269.93,173.225 277.23,173.225 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M280.861,457.549v47.225c-8.177,0.806-16.463,1.215-24.857,1.215 c-8.117,0-16.138-0.385-24.051-1.142v-47.297l24.448-13.625L280.861,457.549z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#90BC42"
    },
    points: "256.233,62.012 277.23,173.225 269.93,173.225 242.547,173.225 235.248,173.225 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M256.233,277.115c13.048,0,23.618,10.583,23.618,23.618c0,13.036-10.571,23.606-23.618,23.606 c-13.036,0-23.606-10.571-23.606-23.606C232.626,287.698,243.197,277.115,256.233,277.115z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "269.93,229.89 269.93,232.728 242.547,232.728 242.547,229.89 242.547,174.175 242.547,173.225 269.93,173.225 269.93,174.175 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "242.547,229.89 242.547,232.728 224.593,232.728 224.593,173.225 235.248,173.225 242.547,173.225 242.547,174.175 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M231.953,457.549v47.297c-12.507-1.191-24.737-3.307-36.63-6.277V460.82v-3.271L231.953,457.549 L231.953,457.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M195.323,460.82v37.749c-68.727-17.137-126.186-62.702-159.172-123.48v-16.68l13.757,10.017 l13.769-10.017v32.205h25.531v-32.205l13.769,10.017l13.781-10.017v32.205h25.494v-32.205l13.769,10.017l13.769-10.017v32.205 h25.531v35.259v31.676L195.323,460.82L195.323,460.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M272.882,31.222c-0.984-3.029-4.155-4.767-7.241-3.961L262.43,28.1l-0.196-3.324 c-0.186-3.178-2.819-5.66-6.002-5.66c-0.001,0-0.002,0-0.004,0c-3.184,0.001-5.816,2.487-6,5.667l-0.191,3.315l-3.206-0.838 c-3.079-0.806-6.257,0.931-7.239,3.961c-0.982,3.029,0.566,6.3,3.533,7.457l3.086,1.205l-1.789,2.794 c-1.718,2.682-1.047,6.239,1.53,8.109c1.064,0.773,2.302,1.147,3.53,1.147c1.745,0,3.471-0.758,4.655-2.203l2.098-2.563 l2.106,2.566c2.019,2.46,5.608,2.921,8.184,1.05c2.576-1.872,3.246-5.427,1.528-8.108l-1.791-2.794l3.086-1.205 C272.317,37.521,273.866,34.252,272.882,31.222z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M256.236,271.108c-16.335,0-29.625,13.29-29.625,29.625c0,16.336,13.29,29.625,29.625,29.625 s29.625-13.29,29.625-29.625C285.862,284.398,272.571,271.108,256.236,271.108z M256.236,318.332c-9.705,0-17.6-7.895-17.6-17.6 c0-9.705,7.895-17.6,17.6-17.6c9.705,0,17.6,7.895,17.6,17.6C273.836,310.437,265.941,318.332,256.236,318.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M212.79,405.918c3.32,0,6.013-2.693,6.013-6.013v-11.333c0-3.32-2.693-6.013-6.013-6.013 s-6.013,2.693-6.013,6.013v11.333C206.777,403.225,209.468,405.918,212.79,405.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M234.749,405.918c3.32,0,6.013-2.693,6.013-6.013v-11.333c0-3.32-2.693-6.013-6.013-6.013 c-3.32,0-6.013,2.693-6.013,6.013v11.333C228.736,403.225,231.428,405.918,234.749,405.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M256.709,405.918c3.32,0,6.013-2.693,6.013-6.013v-11.333c0-3.32-2.693-6.013-6.013-6.013 c-3.32,0-6.013,2.693-6.013,6.013v11.333C250.696,403.225,253.387,405.918,256.709,405.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M278.668,405.918c3.32,0,6.013-2.693,6.013-6.013v-11.333c0-3.32-2.693-6.013-6.013-6.013 c-3.32,0-6.013,2.693-6.013,6.013v11.333C272.655,403.225,275.348,405.918,278.668,405.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M300.627,405.918c3.32,0,6.013-2.693,6.013-6.013v-11.333c0-3.32-2.693-6.013-6.013-6.013 c-3.32,0-6.013,2.693-6.013,6.013v11.333C294.614,403.225,297.306,405.918,300.627,405.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M262.249,294.721v-3.55c0-3.32-2.693-6.013-6.013-6.013c-3.32,0-6.013,2.693-6.013,6.013v9.563 c0,3.32,2.693,6.013,6.013,6.013h9.445c3.32,0,6.013-2.693,6.013-6.013c0-3.32-2.693-6.013-6.013-6.013H262.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M498.636,337.681c8.662-25.663,13.363-53.133,13.363-81.681C512,114.841,397.159,0,256.001,0 S0,114.841,0,255.999s114.842,255.999,255.999,255.999c112.093,0,207.58-72.422,242.155-172.928 C498.365,338.632,498.538,338.172,498.636,337.681z M378.666,342.507h105.449c-1.433,3.769-2.958,7.492-4.571,11.168 c-0.298-0.232-0.613-0.449-0.958-0.624c-2.017-1.027-4.436-0.835-6.265,0.497l-10.231,7.444l-10.233-7.444 c-1.829-1.33-4.25-1.522-6.265-0.495c-2.015,1.026-3.284,3.097-3.284,5.359v26.192h-13.505v-26.192c0-2.262-1.27-4.333-3.284-5.359 c-2.017-1.027-4.437-0.835-6.265,0.497l-10.231,7.444l-10.233-7.444c-1.829-1.33-4.251-1.522-6.265-0.495 c-2.016,1.026-3.284,3.097-3.284,5.359v26.192h-13.481v-26.192c0-2.262-1.27-4.333-3.285-5.359 c-2.016-1.026-4.436-0.833-6.267,0.498l-2.618,1.906v-33.796h127.404c-0.83,2.964-1.718,5.905-2.656,8.822H378.668 c-3.32,0-6.013,2.693-6.013,6.013S375.345,342.507,378.666,342.507z M460.441,288.023c13.169,0,25.564,4.81,35.238,13.594 c-0.51,2.688-1.061,5.361-1.658,8.016h-76.016C427.782,296.265,443.553,288.023,460.441,288.023z M256.001,12.026 c134.528,0,243.974,109.446,243.974,243.974c0,10.835-0.72,21.506-2.096,31.973c-9.244-6.619-20.01-10.644-31.424-11.69v-11.139 c0-3.32-2.693-6.013-6.013-6.013s-6.013,2.693-6.013,6.013v11.149c-21.235,2.011-40.362,14.551-50.637,33.342h-46.218 c-3.32,0-6.013,2.693-6.013,6.013v42.126l-5.807-4.225c-1.829-1.33-4.251-1.522-6.265-0.495c-2.016,1.026-3.284,3.097-3.284,5.359 v26.192h-13.506v-46.561c0-3.32-2.693-6.013-6.013-6.013H304.28v-68.602c0-3.32-2.693-6.013-6.013-6.013h-4.376v-84.186 c0-3.32-2.693-6.013-6.013-6.013h-5.665L262.146,60.901c-0.536-2.84-3.017-4.898-5.908-4.898s-5.372,2.056-5.908,4.898 l-20.067,106.316h-5.665c-3.32,0-6.013,2.693-6.013,6.013v84.186h-4.376c-3.32,0-6.013,2.693-6.013,6.013v68.602h-12.877 c-3.32,0-6.013,2.693-6.013,6.013v46.561h-13.5v-26.192c0-2.262-1.269-4.333-3.284-5.359c-2.017-1.027-4.436-0.835-6.265,0.495 l-10.233,7.444l-10.231-7.444c-1.829-1.33-4.25-1.522-6.265-0.497c-2.016,1.026-3.284,3.097-3.284,5.359v26.192h-13.469V358.41 c0-2.261-1.269-4.332-3.283-5.357c-2.014-1.027-4.435-0.835-6.264,0.494l-10.245,7.446l-10.234-7.445 c-1.829-1.33-4.25-1.522-6.265-0.495c-2.016,1.026-3.284,3.097-3.284,5.359v26.192H69.689v-26.192c0-2.262-1.27-4.333-3.284-5.359 c-2.017-1.027-4.436-0.835-6.265,0.497l-10.23,7.443l-10.219-7.441c-1.829-1.332-4.25-1.525-6.267-0.498 c-0.348,0.177-0.664,0.394-0.964,0.63c-13.127-29.928-20.433-62.967-20.433-97.684C12.026,121.472,121.472,12.026,256.001,12.026z M263.918,179.241v47.476h-15.364v-47.476H263.918z M275.944,179.241h5.919v47.476h-5.919V179.241z M242.498,167.215l13.738-72.782 l13.738,72.782H242.498z M230.608,179.241h5.92v47.476h-5.92V179.241z M230.608,238.743h51.256v18.67h-51.256V238.743z M220.219,269.439h72.034v62.589h-72.034V269.439z M215.514,344.054v18.387c0,3.32,2.693,6.013,6.013,6.013l0,0 c3.32,0,6.013-2.693,6.013-6.013v-18.387h22.448v18.387c0,3.32,2.693,6.013,6.013,6.013l0,0c3.32,0,6.013-2.693,6.013-6.013 v-18.387h22.448v18.387c0,3.32,2.693,6.013,6.013,6.013l0,0c3.32,0,6.013-2.693,6.013-6.013v-18.387h14.184v75.812H201.337 l-0.005-75.812H215.514z M201.335,463.563h24.605v34.559c-8.337-1.029-16.547-2.475-24.605-4.326L201.335,463.563L201.335,463.563z M230.389,451.537h-29.054v-19.646h109.335v19.645h-28.248l-23.097-12.865c-1.819-1.014-4.035-1.013-5.853,0L230.389,451.537z M286.874,463.563h23.799v30.231c-7.799,1.792-15.738,3.212-23.799,4.234V463.563z M42.163,373.353v-3.128l4.205,3.062 c2.109,1.536,4.968,1.537,7.077,0.001l4.219-3.069v20.394c0,3.32,2.693,6.013,6.013,6.013h25.531c3.32,0,6.013-2.693,6.013-6.013 v-20.394l4.22,3.07c2.109,1.533,4.964,1.534,7.072,0.001l4.233-3.077v20.4c0,3.32,2.693,6.013,6.013,6.013h25.494 c3.32,0,6.013-2.693,6.013-6.013v-20.394l4.219,3.069c2.108,1.534,4.965,1.534,7.075,0l4.22-3.07v20.394 c0,3.32,2.693,6.013,6.013,6.013h19.513v64.197h0.005v29.886C126.097,472.723,73.276,429.822,42.163,373.353z M237.966,499.307 v-38.225l18.437-10.275l18.446,10.275v38.17c-6.221,0.477-12.507,0.722-18.848,0.722 C249.934,499.974,243.922,499.743,237.966,499.307z M322.699,490.707v-94.081h19.518c3.32,0,6.013-2.693,6.013-6.013v-20.394 l4.22,3.07c2.109,1.534,4.968,1.533,7.077-0.001l4.205-3.062v20.388c0,3.32,2.693,6.013,6.013,6.013h25.506 c3.32,0,6.013-2.693,6.013-6.013v-20.394l4.22,3.07c2.108,1.533,4.967,1.534,7.075,0l4.219-3.069v20.394 c0,3.32,2.693,6.013,6.013,6.013h25.531c3.32,0,6.013-2.693,6.013-6.013v-20.394l4.22,3.07c2.108,1.533,4.967,1.534,7.075,0 l4.219-3.069v3.121c-7.639,13.866-16.586,26.91-26.675,38.97c-0.183-3.157-2.776-5.667-5.978-5.667h-12.828 c-3.32,0-6.013,2.693-6.013,6.013s2.693,6.013,6.013,6.013h12.828c0.177,0,0.343-0.037,0.516-0.052 C407.333,452.522,367.646,477.917,322.699,490.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M354.615,418.67h-12.828c-3.32,0-6.013,2.693-6.013,6.013c0,3.32,2.693,6.013,6.013,6.013h12.828 c3.32,0,6.013-2.693,6.013-6.013C360.628,421.362,357.935,418.67,354.615,418.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M170.22,407.446h-12.828c-3.32,0-6.013,2.693-6.013,6.013s2.693,6.013,6.013,6.013h12.828 c3.32,0,6.013-2.693,6.013-6.013S173.54,407.446,170.22,407.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M134.545,435.105c0-3.32-2.693-6.013-6.013-6.013h-12.828c-3.32,0-6.013,2.693-6.013,6.013 s2.693,6.013,6.013,6.013h12.828C131.852,441.118,134.545,438.426,134.545,435.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M142.963,443.523h-12.828c-3.32,0-6.013,2.693-6.013,6.013s2.693,6.013,6.013,6.013h12.828 c3.32,0,6.013-2.693,6.013-6.013S146.283,443.523,142.963,443.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M381.872,434.705h-12.828c-3.32,0-6.013,2.693-6.013,6.013s2.693,6.013,6.013,6.013h12.828 c3.32,0,6.013-2.693,6.013-6.013S385.193,434.705,381.872,434.705z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoscow);
export default __webpack_public_path__ + "static/media/moscow.2cc86cf8120f385390c6df65259b178d.svg";
export { ForwardRef as ReactComponent };